import { useMutation } from "@tanstack/react-query";
import { assignDriverToVerificationStages } from "../api.ts";
import type { AssignDriverRequest } from "../../types.ts";
import { success } from "@";

// Mutation hook for assigning a driver to verification stages
export const useAssignDriverMutation = () => {
  return useMutation({
    mutationFn: async (data: AssignDriverRequest) => {
      const response = await assignDriverToVerificationStages(data);
      return response.data;
    },
    onSuccess: async () => {
      await success("تم اسناد الطلبات بنجاح");
      window.location.reload();
    },
  });
};
